import { Container } from 'src/components/department/Container'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'
import { getFeatureObject } from 'src/utils/amplitude/getFeatureObject'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'
import '../PictosDepartamento/pictos.scss'
import { useMemo } from 'react'
import { getResponsiveVisibility } from 'src/utils/getResponsiveVisibility'

import type { PictosHomeItemData } from './pictosHome.constants'
import { DATA_BANNER_TYPE, MAX_PICTOS_TO_SHOW } from './pictosHome.constants'
import { PictosHomeItem } from './PictosHomeItem'

type Props = {
  items: PictosHomeItemData[]
  parentComponent?: string
  section?: string
  enableSession?: boolean
  showOnMobile?: boolean
  showOnDesktop?: boolean
  locationOnPage?: string
}

export function PictosHome(props: Props) {
  const { pageData } = useGlobalContext()
  const standardObject = getStandardObject(pageData)

  const {
    section,
    locationOnPage,
    items,
    enableSession,
    showOnDesktop,
    showOnMobile,
  } = props

  const visibilityClasses = useMemo(() => {
    return getResponsiveVisibility(showOnDesktop, showOnMobile)
  }, [showOnDesktop, showOnMobile])

  const handleClickLink = (name: string, imageAlt: string, index: number) => {
    if (!locationOnPage || !section) {
      return
    }

    const featureObject = getFeatureObject({
      section,
      locationOnPage,
      name: name
        ? `${DATA_BANNER_TYPE} | ${name}`
        : imageAlt
        ? `${DATA_BANNER_TYPE} | ${imageAlt}`
        : 'N/A',
      index,
    })

    dispatchAmplitudeEvent({
      eventName: 'Promotional Element Selected',
      eventData: {
        ...standardObject,
        ...featureObject,
      },
    })

    if (!window) {
      return
    }

    window.dataLayer = window.dataLayer ?? []

    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: 'event_track',
      event_category: 'clique',
      event_action: name,
      event_label: 'Pagina de departamento',
    })
  }

  const sendPromoFeatureViewedEvent = (
    item: PictosHomeItemData,
    index: number
  ) => {
    if (!locationOnPage || !section) {
      return
    }

    const eventData = {
      ...getStandardObject(pageData),
      ...getFeatureObject({
        section,
        locationOnPage,
        name: item?.text
          ? `${DATA_BANNER_TYPE} | ${item?.text}`
          : item?.altImage
          ? `${DATA_BANNER_TYPE} | ${item?.altImage}`
          : 'N/A',
        index,
      }),
    }

    dispatchAmplitudeEvent({ eventName: 'Promo Feature Viewed', eventData })
  }

  const itemsToShow = items.slice(0, MAX_PICTOS_TO_SHOW)

  if (!enableSession) return null

  return (
    <Container
      className={`restructure-maxMobile:my-6  restructure-small-desktop:mb-10 restructure-small-desktop:mt-8 !px-0 ${visibilityClasses}`}
    >
      <ul
        className={`${
          itemsToShow.length <= 4 ? 'lg:justify-center gap-10' : ''
        } pictos flex items-start justify-start max-w-full overflow-x-scroll scrollbar-hide gap-2.5 sm:gap-6 xl:gap-10 sm:justify-center restructure-maxMobile:px-4 restructure-maxMobile:mr-4`}
      >
        {itemsToShow?.map((item, index) => (
          <PictosHomeItem
            key={`${item.linkUrl}-${item.text}-${index}`}
            item={item}
            index={index}
            onSelect={handleClickLink}
            onView={sendPromoFeatureViewedEvent}
          />
        ))}
      </ul>
    </Container>
  )
}
